import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Autocomplete,
} from '@mui/material';

const LeaveSettingsForm = ({ open, mode, formData, formErrors, allEmployees, onClose, onSubmit, onInputChange }) => {
  const getDialogTitle = () => {
    switch (mode) {
      case 'add':
        return 'Add Leave Settings';
      case 'edit':
        return 'Edit Leave Settings';
      case 'view':
        return 'View Leave Settings';
      default:
        return 'Leave Settings';
    }
  };

  const isViewMode = mode === 'view';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{getDialogTitle()}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <Autocomplete
              value={allEmployees.find((emp) => emp.id.toString() === formData.employee.toString()) || null}
              onChange={(event, newValue) => {
                onInputChange('employee', newValue?.id || '');
              }}
              options={allEmployees}
              getOptionLabel={(option) => option?.full_name || ''}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee"
                  error={!!formErrors.employee}
                  helperText={formErrors.employee}
                />
              )}
              disabled={isViewMode}
              clearOnEscape
              fullWidth
              loading={allEmployees.length === 0}
              loadingText="Loading employees..."
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Sick Leaves Per Annum"
              type="number"
              value={formData.sick_leaves_per_annum}
              onChange={(e) =>
                onInputChange('sick_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.sick_leaves_per_annum}
              helperText={formErrors.sick_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Casual Leaves Per Annum"
              type="number"
              value={formData.casual_leaves_per_annum}
              onChange={(e) =>
                onInputChange('casual_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.casual_leaves_per_annum}
              helperText={formErrors.casual_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Earned Leaves Per Annum"
              type="number"
              value={formData.earned_leaves_per_annum}
              onChange={(e) =>
                onInputChange('earned_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.earned_leaves_per_annum}
              helperText={formErrors.earned_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Maternity Leaves Per Annum"
              type="number"
              value={formData.maternity_leaves_per_annum}
              onChange={(e) =>
                onInputChange('maternity_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.maternity_leaves_per_annum}
              helperText={formErrors.maternity_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Paternity Leaves Per Annum"
              type="number"
              value={formData.paternity_leaves_per_annum}
              onChange={(e) =>
                onInputChange('paternity_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.paternity_leaves_per_annum}
              helperText={formErrors.paternity_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Unpaid Leaves Per Annum"
              type="number"
              value={formData.unpaid_leaves_per_annum}
              onChange={(e) =>
                onInputChange('unpaid_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.unpaid_leaves_per_annum}
              helperText={formErrors.unpaid_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Other Leaves Per Annum"
              type="number"
              value={formData.other_leaves_per_annum}
              onChange={(e) =>
                onInputChange('other_leaves_per_annum', e.target.value === '' ? '' : parseInt(e.target.value, 10))
              }
              error={!!formErrors.other_leaves_per_annum}
              helperText={formErrors.other_leaves_per_annum}
              disabled={isViewMode}
              inputProps={{ min: 0, max: 365 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{isViewMode ? 'Close' : 'Cancel'}</Button>
        {!isViewMode && (
          <Button variant="contained" onClick={onSubmit}>
            {mode === 'edit' ? 'Update' : 'Create'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default LeaveSettingsForm;
